export const colors = {
  mainColor: "#E63C3C",
};
